import { appUrls } from "../../../../EasyProjectsCommon/AppUrls";
import { api } from "../../../Actions";

export enum CustomizationActionTypes {
    LOAD_CUSTOMIZATION_SUCCESS = "LOAD_CUSTOMIZATION_SUCCESS",
}

export const loadCustomization = api.runOnce(
    api.postJson(() => ({
        endpoint: appUrls.customization.getForClient,
        types: {
            successType: CustomizationActionTypes.LOAD_CUSTOMIZATION_SUCCESS,
        },
        additionalParams: { postWithAuthToken: true },
    }))
);
